import { createSelector } from '@ngrx/store';
import { selectAllTimestampTypes } from 'src/store/entityStores/entity-store-selectors';

export function selectTimestampTypeById(id: string) {
  return createSelector(selectAllTimestampTypes, (timestampTypes) => {
    return timestampTypes.get(id);
  });
}

export function selectTimestampTypeByName(name: string) {
  return createSelector(selectAllTimestampTypes, (timestampTypes) => {
    return timestampTypes.find((t) => t.name === name);
  });
}
